import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const InputError = styled.div`
  font-size: 12px;
  color: ${token('colors.red400')};
  padding-top: 8px;
`;
